module.exports = __webpack_public_path__ + "img/27.2fa6d5c3.jpg";